import { Grid } from '@material-ui/core';
import * as React from 'react';

import { Zoom } from '../Zoom';

import './index.scss';

interface IProps {
    content: string[];
    setSelectedSrc: (src: string) => void;
}

export const MultiMedia: React.FC<IProps> = ({ content, setSelectedSrc }) => {
    return (
        <Grid
            container
            className="multipleMedia"
            spacing={2}
        >
            {content.map((src, i) => {
                const { length } = content;

                if (length % 2 !== 0) {
                    if (i === 0) {
                        return (
                            <Grid
                                key={i}
                                item
                                md={12}
                            >
                                <div className={'multipleMedia-img fullHeight'}>
                                    <Zoom onClick={() => setSelectedSrc(src)} />
                                    <img src={src} alt="" />
                                </div>
                            </Grid>
                        );
                    } else {
                        return (
                            <Grid
                                key={i}
                                item
                                md={6}
                            >
                                <div className={'multipleMedia-img halfHeight'}>
                                    <Zoom onClick={() => setSelectedSrc(src)} />
                                    <img src={src} alt="" />
                                </div>
                            </Grid>
                        );
                    }
                } else {
                    return (
                        <Grid
                            key={i}
                            item
                            md={6}
                        >
                            <div className={'multipleMedia-img halfHeight'}>
                                <Zoom onClick={() => setSelectedSrc(src)} />
                                <img src={src} alt="" />
                            </div>
                        </Grid>
                    );
                }
            })}
        </Grid>
    );
};
